import React, {Component} from 'react';
import Attachment from "./Attachment";

class Attachments extends Component {
    constructor(props) {
        super(props);
    }

    showAttachments(attachment) {

        let result = (
                <Attachment submission={this.props.submission} attachment={attachment} key={attachment.canvas_attachment_id} isReviewed={this.props.isReviewed}/>
        );

        return result;
    }

    render() {
        return (
            <div>
                {this.props.submission.attachments.map(attachment =>
                    this.showAttachments(attachment))
                }
            </div>
        );
    }
}

export default Attachments;
